let rainforestScriptPromise = null;

export function loadRainforestPayScript() {
  if (rainforestScriptPromise) return rainforestScriptPromise;

  const scriptSrc =
    process.env.REACT_APP_ENVIRONMENT === "production"
      ? "https://static.rainforestpay.com/payment.js"
      : "https://static.rainforestpay.com/sandbox.payment.js";

  rainforestScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${scriptSrc}"]`);

    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.type = "module";
    script.src = scriptSrc;

    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error(`Failed to load Rainforest Pay script`));

    document.head.appendChild(script);
  });

  return rainforestScriptPromise;
}
